import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

export type ChatViewMode = 'list' | 'form';

@Injectable({
  providedIn: 'root'
})
export class MessagesStateService {
  private viewMode$$ = new BehaviorSubject<ChatViewMode>('list');
  viewMode$ = this.viewMode$$.asObservable();

  private _chatUnauthorized = new BehaviorSubject(false);
  chatUnauthorized$ = this._chatUnauthorized.asObservable();

  openTicketForm() {
    this.viewMode$$.next('form');
  }

  backToList() {
    this.viewMode$$.next('list');
  }

  setUnauthorized() {
    this._chatUnauthorized.next(true);
  }

  get chatUnauthorized() {
    return this._chatUnauthorized.value;
  }
}
